<template>
  <scroll-area>
    <template slot="body">
      <v-treeview
        light
        disable-resize-watcher="true"
        style="cursor: pointer; width: 100%"
        :items="getTree"
        :active.sync="treeActive"
        :open.sync="$store.state.structure.manage.treeOpen"
        loading-icon="autorenew"
        expand-icon="expand_more"
        active-class="active"
        class="blacktext--text caption font-weight-medium font-condensend"
        item-disabled="disabled"
        activatable
        item-key="id"
        return-object
      >
        <template v-slot:label="{ item, open, active }" :data-testid="$options.name + '__template__' + item.$id" >
          <v-layout @contextmenu.prevent="contextHandler" fill-height align-center class="treeLeaf" px-0>
            <span class="blacktext--text body-1 font-weight-medium font-condensend px-2">{{
              item.name
            }}</span>
          </v-layout>
        </template>
      </v-treeview>
    </template>
  </scroll-area>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'

// Типы
interface TreeNode {
  id?: string
  name?: string
  children?: TreeNode[]
  [key: string]: any
}

interface TemplateData {
  tree?: TreeNode[]
  [key: string]: any
}

interface ManageState {
  treeActive: TreeNode[]
}

interface StructureState {
  manage: ManageState
}

export default Vue.extend({
  name: 'MANAGE_TREE',

  components: {
    scrollArea,
  },

  props: {
    template: {
      type: Object as () => TemplateData,
      default: () => ({})
    },
  },

  data(): {
    currentActive: TreeNode | null
  } {
    return {
      currentActive: null,
    }
  },

  computed: {
    getTree(): TreeNode[] {
      if (this.template?.tree) {
        return this.template.tree
      }
      return (this.$store.state.structure as StructureState).manage.tree
    },

    treeActive: {
      get(): TreeNode[] {
        return (this.$store.state.structure as StructureState).manage.treeActive
      },
      set(newVal: TreeNode[]): void {
        if (!newVal?.length) {
          if (this.currentActive?.id) {
            this.$nextTick(() => {
              this.$set((this.$store.state.structure as StructureState).manage, 'treeActive', [this.currentActive])
            })
          }
          return
        }
        
        if (Array.isArray(newVal) && newVal.length) {
          if (newVal[0].id === this.currentActive?.id) {
            return
          }
          if (!this.currentActive) {
            this.currentActive = newVal[0]
          }
        }
        
        this.$set((this.$store.state.structure as StructureState).manage, 'treeActive', newVal)
        this.currentActive = newVal[0]
      },
    },
  },

  async created(): Promise<void> {
    this.setup()
  },

  methods: {
    setup(): void {
      console.log('MANAGE_TREE', 'TEMPLATE', this.template)
    },
  },
})
</script>

<style lang="css" scoped>
.activeElement{
  border-radius: 14px;
}

</style>
